import { ProjectModelDataFieldType } from './model-data-field-type.enum';

export const PROJECT_MODEL_FIELD_DEFAULT_DATA = {
  type: ProjectModelDataFieldType.String,
  isArray: false
};
